import React, { forwardRef } from 'react';
import { Content } from '@radix-ui/react-dialog';
import type { DialogContentProps } from '@radix-ui/react-dialog';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { variants } from './ModalContent.variants';

type DialogContentSize = 'small' | 'medium' | 'large';

export interface ModalContentProps extends DialogContentProps {
  topAligned?: boolean;
  size?: DialogContentSize;
  dismissable?: boolean;
}

export const ModalContent = forwardRef<HTMLDivElement, ModalContentProps>(
  (
    {
      dismissable = true,
      onPointerDownOutside,
      onEscapeKeyDown,
      size,
      topAligned,
      className,
      ...props
    },
    forwardedRef,
  ) => {
    const handlePointerDownOutside: DialogContentProps['onPointerDownOutside'] =
      (e) => {
        if (insideToasts(e.target)) e.preventDefault();
        if (!dismissable) e.preventDefault();
        if (onPointerDownOutside) onPointerDownOutside(e);
      };
    const handleEscapeKeyDown: DialogContentProps['onEscapeKeyDown'] = (e) => {
      if (!dismissable) e.preventDefault();
      if (onEscapeKeyDown) onEscapeKeyDown(e);
    };
    return (
      <Content
        ref={forwardedRef}
        aria-describedby={undefined}
        onPointerDownOutside={handlePointerDownOutside}
        onEscapeKeyDown={handleEscapeKeyDown}
        className={cn(
          topAligned ? 'grow-top' : 'grow-center',
          variants({ size, topAligned }),
          className,
        )}
        {...props}
      />
    );
  },
);

function insideToasts(element: any) {
  const toasts = document.getElementById('toasts');
  return toasts?.contains(element);
}
